<template>
  <div v-if="info !== null" class="container">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.profile}}</h1>
        <div class="flexBox">
          <div class="flexInner">
            <div class="innerItem">
              <p class="role">
                <span class="icoUserRole" :data-role="info.userRole"></span>
                {{info.userRole}}
              </p>
            </div>
            <div class="innerItem">
              <p class="innerTitle">{{locale.nickname}}</p>
              <div class="nickname">
                <input type="text" class="input" v-model="nickname" @keyup.enter="updateNickname" @click="activeNickname = true" />
                <button v-show="activeNickname" type="submit" class="btn btnWhite sizeXs" @click="updateNickname">{{locale.modify}}</button>
              </div>
            </div>
            <div class="innerItem">
              <p class="innerTitle">{{ locale.pw_change }}</p>
              <button type="button" class="btn btnWhite" @click="changePw">{{ locale.do_change_pw }}</button>
            </div>
            <!-- <div class="innerItem">
              <p class="innerTitle">{{locale.pw_change}}</p>
              <div class="mb10">
                <p class="innerLabel colorGrey">{{locale.pw_old}}</p>
                <input type="password" class="input" v-model="password.oldPw" />
              </div>
              <div class="mb10">
                <p class="innerLabel colorGrey">{{locale.pw_new}}</p>
                <input type="password" class="input" v-model="password.newPw" />
              </div>
              <div class="mb10">
                <p class="innerLabel colorGrey">{{locale.pw_new2}}</p>
                <input type="password" class="input" v-model="password.newPw2" @keyup.enter="updatePassword" />
              </div>
              <button v-show="activePw" type="button" class="btn btnFull toCapitalize" @click="updatePassword">{{locale.modify}}</button>
            </div> -->
          </div>
          <div class="flexInner"></div>
        </div>
      </div>
      <div class="innerSide"><div class="sideBox">
      </div></div>
    </section>
    <div id="setContent">
    </div>
  </div>
</template>

<script>
import ChangePassword from './ChangePassword.vue'
export default {
  components: { ChangePassword },
  name: 'MyInfo',
  props: [
    'locale'
  ],
  computed: {
    info () {
      return this.$store.getters['authentication/getMyAccount']
    },
    activePw () {
      return !!this.password.oldPw.length && !!this.password.newPw.length && !!this.password.newPw2.length
    }
  },
  created () {
    this.$store.dispatch('authentication/getMyAccount').then((res) => {
      if (res.status === 200) {
        this.nickname = res.message.sgnickname
      } else {
        alert(`account error: ${res.message}`)
        this.$router.replace({
          path: '/'
        })
      }
    })
  },
  data () {
    return {
      activeNickname: false,
      nickname: '',
      password: {
        oldPw: '',
        newPw: '',
        newPw2: ''
      }
    }
  },
  methods: {
    changePw () {
      const userId = this.info?.sgusername
      sessionStorage.setItem('tempUserId', userId)
      this.$router.push({
        name: 'change_password'
      })
    },
    validateNickname (nickname) {
      if (nickname.length <= 1 || nickname.length > 10) {
        alert(this.locale.validate_admin_nickname_length)
        return false
      } else {
        return true
      }
    },
    updateNickname () {
      if (this.validateNickname(this.nickname)) {
        if (window.confirm(`${this.locale.confirm_modify_nickname} :: ${this.nickname}`)) {
          const userName = {
            user: this.info.sgusername,
            nickname: this.nickname
          }
          this.$store.dispatch('admin/updateUserNickname', userName).then(() => {
            this.$store.dispatch('authentication/getMyAccount').then((res) => {
              this.$store.commit('authentication/updateMyAccount', { sgnickname: res.message.sgnickname })
              alert(this.locale.complete_modify)
            })
          })
        }
      }
    },
    validatePassword () {
      if (this.password.oldPw.trim() === '') {
        alert(this.locale.validate_change_pw1)
        return false
      } else if (this.password.newPw.trim() === '') {
        alert(this.locale.validate_change_pw2)
        return false
      } else if (this.password.newPw2.trim() === '') {
        alert(this.locale.validate_change_pw3)
        return false
      } else if (this.password.newPw !== this.password.newPw2) {
        alert(this.locale.validate_change_pw4)
        return false
      } else if (this.password.newPw.length < 6 || this.password.newPw.length > 10) {
        alert(this.locale.validate_change_pw_limit)
        return false
      } else {
        return true
      }
    },
    updatePassword () {
      if (this.validatePassword()) {
        if (window.confirm(this.locale.confirm_change_password)) {
          const userInfo = {
            user: this.info.sgusername,
            oldPw: this.password.oldPw,
            newPw: this.password.newPw
          }
          this.$store.dispatch('admin/updatePw', userInfo).then((res) => {
            if (res.message.includes('incorrent old pw')) {
              alert(this.locale.result_fail_change_pw1)
              this.password.oldPw = ''
            } else if (res.message.includes('old and new pw are same')) {
              alert(this.locale.result_fail_change_pw2)
              this.password.newPw = ''
              this.password.newPw2 = ''
            } else if (res.message.includes === 'length') {
              alert(this.locale.validate_change_pw_limit)
            } else {
              alert(this.locale.complete_change_pw)
              this.password.oldPw = ''
              this.password.newPw = ''
              this.password.newPw2 = ''
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.role {
  width: 120px;
  height: 120px;
  margin: 0 auto 1em;
  padding-top: 30px;
  text-align: center;
  border-radius: 100%;
  background-color: rgba($bg-default, 0.5);
  .icoUserRole {
    display: block;
    height: 32px;
    margin: 0 auto 0.3em;
  }
}
.nickname {
  position: relative;
  .input {
    opacity: 0.8;
    cursor: pointer;
    &:focus {
      opacity: 1;
      cursor: initial;
    }
  }
  .btn {
    position: absolute;
    top: 50%;
    right: 5px;
    margin-left: 0;
    transform: translate(0, -50%);
  }
}
</style>
